import { Col, Row } from 'antd';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { User } from 'api/models';
import { Avatar } from 'components/atoms/avatar';
import { Caption01, ProductiveHeading05 } from 'components/styles';
import { fullName } from 'utils/full-name';

const EditHeader = styled(Row)`
  padding: var(--spacing-03) 0 var(--spacing-06);

  .username {
    ${ProductiveHeading05};
  }
  .email {
    ${Caption01};
    color: var(--gray-70);
  }
  .ant-avatar-string {
    font-size: var(--heading-6-size);
  }
`;

const StyledAvatar = styled(Avatar)`
  position: absolute;
  .ant-avatar-string {
    font-size: var(--heading-5-size);
  }
`;
const StyledDiv = styled.div`
  height: var(--layout-04);
`;

const EditModeHeader = ({ user }): JSX.Element => {
  const { photoUrl, emailId } = user;

  return (
    <EditHeader align="middle">
      <Col span={3}>
        <Avatar size={56} src={photoUrl} name={fullName(user)} />
      </Col>
      <Col span={12}>
        <div className="username">{fullName(user)}</div>
        <div className="email">{emailId}</div>
      </Col>
    </EditHeader>
  );
};

export const TeamMemberDrawerHeader: FC<{ readOnly: boolean; user?: User }> = ({
  readOnly,
  user,
}) =>
  !user ? (
    <StyledDiv>
      <FormattedMessage id="settings.team_members.invite_members.title" />
    </StyledDiv>
  ) : readOnly ? (
    <StyledDiv>
      <StyledAvatar size={72} src={user?.photoUrl} name={fullName(user)} />
    </StyledDiv>
  ) : (
    <EditModeHeader user={user} />
  );
